module.exports = __webpack_public_path__ + "img/microphone-off-02.9e5197ef.svg";